import React, { useState } from 'react';
import { TranslateScope } from '@pegasus/translation';
import { useIsSmallDevice } from '../../../lib/useIsSmallDevice';
import { MenuItems } from './MenuItems';
import { MobileSubMenu } from './MobileSubMenu';
import { SubMenuName } from './MobileSubMenu/types';
import { Wrapper } from './styles';
const MENU_ITEM_COUNT = 3;
export const MyAccountMenu = ({ isOpen, closeNavigation, csrfToken }) => {
    const [subMenu, setSubMenu] = useState(SubMenuName.none);
    const isSmallDevice = useIsSmallDevice();
    if (isSmallDevice) {
        return null;
    }
    return (React.createElement(Wrapper, { isOpen: isOpen, menuItemCount: MENU_ITEM_COUNT },
        React.createElement(TranslateScope, { path: "myaccount-menu" },
            React.createElement(MenuItems, { setSubMenu: setSubMenu, closeNavigation: closeNavigation, csrfToken: csrfToken })),
        React.createElement(TranslateScope, { path: "myaccount-submenu" },
            React.createElement(MobileSubMenu, { currSubMenu: subMenu, closeSubmenu: () => {
                    setSubMenu(SubMenuName.none);
                } }))));
};
//# sourceMappingURL=index.js.map